// extracted by mini-css-extract-plugin
export default {"list":"AuthNav_list__ddR2t","item":"AuthNav_item__ygGGI"};